import { render, staticRenderFns } from "./auditFlowDraggable.vue?vue&type=template&id=6a0ff1f9&scoped=true&"
import script from "./auditFlowDraggable.vue?vue&type=script&lang=ts&"
export * from "./auditFlowDraggable.vue?vue&type=script&lang=ts&"
import style0 from "./auditFlowDraggable.vue?vue&type=style&index=0&id=6a0ff1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ff1f9",
  null
  
)

export default component.exports